import React from 'react';

// Regex to match URLs
const URL_REGEX = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;

const LinkifyText = ({ text, className = '' }) => {
  if (!text) return null;

  const parts = text.split(URL_REGEX);
  
  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.match(URL_REGEX)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline break-all"
              onClick={(e) => e.stopPropagation()}
            >
              {part.length > 50 ? part.substring(0, 47) + '...' : part}
            </a>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </span>
  );
};

export default LinkifyText;
